import Presets from './Presets';
export default Presets;



/** WEBPACK FOOTER **
 ** ./src/components/Presets/index.js
 **/